import React from "react";
import { ArrowUpRight, ShieldCheck, CreditCard } from "lucide-react";
import { PRICING, BONUSES } from "../mock";

export default function PrezzoCTA({ onOpenBooking, onOpenCheckout }) {
  return (
    <section id="prezzo" className="py-24 lg:py-36 relative overflow-hidden">
      <div className="absolute inset-0 gradient-bottom pointer-events-none" />
      <div className="container-max relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6">
            <span className="section-label">L’offerta</span>
            <h2 className="font-display text-4xl lg:text-6xl leading-[1] text-white mt-6">
              Ecco quanto<br />
              <span className="italic font-light text-white/60">devi investire.</span>
            </h2>
            <p className="text-white/70 text-lg mt-8 max-w-lg leading-relaxed">
              Percorso completo <span className="text-white">All‑In Experience</span> + tutti i 5 Bonus,
              con un ulteriore <span className="text-lime">incentivo del 10%</span> se agisci subito.
            </p>

            <div className="mt-10 space-y-3">
              {BONUSES.map((b) => (
                <div key={b.id} className="flex items-center justify-between border-b border-white/10 pb-3">
                  <div className="flex items-center gap-3">
                    <span className="font-mono-label text-white/40 text-[10px]">{b.tag}</span>
                    <span className="text-white/85 text-sm lg:text-base">{b.name}</span>
                  </div>
                  <span className="font-display text-white/70">{b.value}</span>
                </div>
              ))}
              <div className="flex items-center justify-between border-b border-white/10 pb-3">
                <div className="flex items-center gap-3">
                  <span className="font-mono-label text-white/40 text-[10px]">CORSO</span>
                  <span className="text-white/85 text-sm lg:text-base">All‑In Experience — 5 corsi in 4 giornate</span>
                </div>
                <span className="font-display text-white/70">2.540 €</span>
              </div>
              <div className="flex items-center justify-between pt-4">
                <div className="font-mono-label text-white/60 text-xs">Valore totale</div>
                <div className="font-display text-3xl text-white line-through decoration-white/30">{PRICING.totalValue}</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="bg-card border border-white/10 rounded-3xl p-8 lg:p-12 relative overflow-hidden">
              <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full bg-lime opacity-[0.06] blur-3xl" style={{ background: "#d4ff3d" }} />
              <div className="font-mono-label text-lime text-xs" style={{ color: "#d4ff3d" }}>Early Bird — disponibile ora</div>
              <div className="mt-6 flex items-baseline gap-3">
                <span className="text-white/40 text-2xl line-through decoration-white/30">€ {PRICING.standard}</span>
              </div>
              <div className="mt-2 flex items-baseline gap-2">
                <span className="font-display text-white text-7xl lg:text-[120px] leading-none font-medium">
                  €{PRICING.today}
                </span>
              </div>
              <div className="text-white/50 text-sm mt-2">{PRICING.vat}</div>

              <div className="mt-8 flex flex-wrap gap-3">
                <button
                  type="button"
                  onClick={() => onOpenCheckout && onOpenCheckout("all-in-experience", "All-In Experience — 5 corsi completi", 1143)}
                  className="btn-primary"
                  data-testid="buy-now-btn"
                >
                  Iscriviti al percorso completo <ArrowUpRight size={18} />
                </button>
                <button
                  type="button"
                  onClick={onOpenBooking}
                  className="btn-secondary"
                >
                  Parla con un consulente
                </button>
              </div>

              <div className="mt-8 grid grid-cols-2 gap-4">
                <div className="flex items-start gap-3 text-white/70 text-sm">
                  <CreditCard size={18} className="text-lime mt-0.5" style={{ color: "#d4ff3d" }} />
                  <div>
                    <div className="text-white text-sm">Pagamento in 3 rate</div>
                    <div className="text-white/50 text-xs mt-1">381€ con PayPal — senza interessi</div>
                  </div>
                </div>
                <div className="flex items-start gap-3 text-white/70 text-sm">
                  <ShieldCheck size={18} className="text-lime mt-0.5" style={{ color: "#d4ff3d" }} />
                  <div>
                    <div className="text-white text-sm">Garanzia Zero Rischi</div>
                    <div className="text-white/50 text-xs mt-1">Rimborso completo entro le 13</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
